import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import './Footer.css';

/**
 * Footer - Site footer with links, social, and copyright
 * @param {string} [className] - Additional CSS classes
 */
const Footer = ({ className = '' }) => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { path: '/', label: 'Home' },
    { path: '/products', label: 'Products' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <footer className={`footer ${className}`}>
      <div className="footer__container container">
        <div className="footer__content">
          {/* Left Column - Links */}
          <div className="footer__section">
            <Link to="/" className="footer__logo" aria-label="AxiomLabs Solutions Home">
              <span className="footer__logo-text">
                <span className="footer__logo-axiom">Axiom</span>
                <span className="footer__logo-labs">Labs</span>
                <span className="footer__logo-solutions">Solutions</span>
              </span>
            </Link>

            <nav className="footer__nav">
              <ul className="footer__links">
                {footerLinks.map((link) => (
                  <li key={link.path} className="footer__link-item">
                    <Link to={link.path} className="footer__link">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Right Column - Social & Info */}
          <div className="footer__section">
            <h4 className="footer__section-title">Connect</h4>
            <SocialLinks size="md" include={['github', 'twitter', 'email']} />

            <p className="footer__note">
              More tools coming soon.
            </p>

            <p className="footer__copyright">
              &copy; {currentYear} AxiomLabs Solutions. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
